import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserConfig } from '../dto/user-config';
import { EmailConfig } from '../dto/email-config';
import { InvoiceConfig } from '../dto/invoice-config';
import { DebtorServiceConfig } from '../dto/debtor-service-config';
import { FeeServiceConfig } from '../dto/fee-service-config';
import { OrderConfig } from '../dto/order-config';
import { WebIdConfig } from '../dto/web-id-config';
import {CustomerConfig} from '../dto/customer-config';
import {TotalCardOrderConfig} from '../dto/total-card-order-config';
import {InvoicePaidConfig} from '../dto/invoice-paid-config';
import {PushNotificationCustomerConfig, PushNotificationLoadsConfig} from "../dto/push-notification-loads-config";

@Injectable()
export class ConfigService {
    readonly apiPath = 'config/';
    constructor(
      private http: HttpClient,
    ) { }


    getUserConfig(): Observable<UserConfig> {
        return this.http.get(this.apiPath + 'user') as Observable<UserConfig>;
    }

    setUserConfig(config: UserConfig): Observable<Object> {
        return this.http.put(this.apiPath + 'user', config) as Observable<Object>;
    }

    getEmailConfig(): Observable<EmailConfig> {
        return this.http.get(this.apiPath + 'email') as Observable<EmailConfig>;
    }

    setEmailConfig(config: EmailConfig): Observable<Object> {
        return this.http.put(this.apiPath + 'email', config) as Observable<Object>;
    }

    getInvoicesConfigs(): Observable<InvoiceConfig[]> {
        return this.http.get(this.apiPath + 'invoices') as Observable<InvoiceConfig[]>;
    }

  getInvoicesPaidConfigs(): Observable<InvoicePaidConfig[]> {
    return this.http.get(this.apiPath + 'invoices-paid') as Observable<InvoicePaidConfig[]>;
  }

    setInvoicesConfigs(configs: InvoiceConfig[]): Observable<InvoiceConfig[]> {
        return this.http.put(this.apiPath + 'invoices', configs) as Observable<InvoiceConfig[]>;
    }

  setInvoicesPaidConfigs(configs: InvoicePaidConfig[]): Observable<InvoicePaidConfig[]> {
    return this.http.put(this.apiPath + 'invoices-paid', configs) as Observable<InvoicePaidConfig[]>;
  }

    getDebtorServiceConfig(): Observable<DebtorServiceConfig> {
        return this.http.get<DebtorServiceConfig>(this.apiPath + 'debtor-service');
    }

    setDebtorServiceConfig(configs: DebtorServiceConfig): Observable<DebtorServiceConfig> {
        return this.http.put<DebtorServiceConfig>(this.apiPath + 'debtor-service', configs);
    }

    getFeeServiceConfig(): Observable<FeeServiceConfig> {
        return this.http.get<FeeServiceConfig>(this.apiPath + 'fees');
    }

    setFeeServiceConfig(configs: FeeServiceConfig): Observable<FeeServiceConfig> {
        return this.http.put<FeeServiceConfig>(this.apiPath + 'fees', configs);
    }

    getOrderConfig(): Observable<OrderConfig> {
        return this.http.get<OrderConfig>(this.apiPath + 'orders');
    }

    setOrderConfig(configs: OrderConfig): Observable<OrderConfig> {
        return this.http.put<OrderConfig>(this.apiPath + 'orders', configs);
    }

    getWebIdConfig(): Observable<WebIdConfig> {
        return this.http.get<WebIdConfig>(this.apiPath + 'web-id');
    }

    setWebIdConfig(configs: WebIdConfig): Observable<WebIdConfig> {
        return this.http.put<WebIdConfig>(this.apiPath + 'web-id', configs);
    }

    getCustomerConfig(): Observable<CustomerConfig> {
      return this.http.get<CustomerConfig>(this.apiPath + 'customers');
    }
  setCustomerConfig(configs: CustomerConfig): Observable<CustomerConfig> {
    return this.http.put<CustomerConfig>(this.apiPath + 'customers', configs);
  }


  getPushNotificationLoadsConfig(): Observable<PushNotificationLoadsConfig> {
      return this.http.get<PushNotificationLoadsConfig>(this.apiPath + 'push-notification-loads');
    }
  setPushNotificationLoadsConfig(configs: PushNotificationLoadsConfig): Observable<PushNotificationLoadsConfig> {
    return this.http.put<PushNotificationLoadsConfig>(this.apiPath + 'push-notification-loads', configs);
  }


    getPushNotificationCustomerConfig(): Observable<PushNotificationCustomerConfig> {
      return this.http.get<PushNotificationCustomerConfig>(this.apiPath + 'push-notification-customer');
    }
  setPushNotificationCustomerConfig(configs: PushNotificationCustomerConfig): Observable<PushNotificationCustomerConfig> {
    return this.http.put<PushNotificationCustomerConfig>(this.apiPath + 'push-notification-customer', configs);
  }



    getTotalCardOrderConfig(): Observable<TotalCardOrderConfig> {
      return this.http.get<TotalCardOrderConfig>(this.apiPath + 'total-card-order');
    }

    setTotalCardOrderConfig(configs: TotalCardOrderConfig): Observable<TotalCardOrderConfig> {
      return this.http.put<TotalCardOrderConfig>(this.apiPath + 'total-card-order', configs);
    }
}
